module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAQCAYAAADAvYV+AAAAmklEQVQokY2SwQrCMBBEU70WpaJ+mGcRpNAe2pN4rp70uwRBQVv6QcUnCwV1ydYsvEBgBjKZdYBQATWw6u9e5FjymQ5YD4nHQKsMW0sszIHmy/ACMksszICnMhSWWJgCd2XYWWJhAlz5nZMlFmLgogzHkQufKPQZZyvgTQXc+wImnq8rQ0vJrbofqu7UqnuhhJuhRRIOf1cU3BsF9yYzEv4v4AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/dark-more.png
// module id = Dfba
// module chunks = 9